import React, { useState } from 'react';
import { Mail, CheckCircle, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) return;

    setStatus('loading');
    try {
      const res = await fetch(`${API_URL}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setStatus('success');
        setMessage(data.message || 'Suscripción exitosa');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(data.detail || 'Error al suscribirse');
      }
    } catch {
      setStatus('error');
      setMessage('Error de conexión. Intenta de nuevo.');
    }
  };

  return (
    <div data-testid="newsletter-signup" className="bg-gradient-to-r from-green-700 to-green-900 rounded-xl p-6 md:p-8">
      <div className="flex flex-col md:flex-row md:items-center md:gap-8">
        <div className="flex-1 mb-4 md:mb-0">
          <h3 className="text-lg font-bold text-white mb-1">Boletín Informativo</h3>
          <p className="text-green-100 text-sm">
            Recibe nuestros mejores artículos, guías y noticias directamente en tu correo. Sin spam.
          </p>
        </div>
        <div className="flex-1">
          {status === 'success' ? (
            <div className="flex items-center gap-2 text-green-100 bg-green-800/50 rounded-lg px-4 py-3">
              <CheckCircle className="w-5 h-5 text-green-300" />
              <span className="text-sm font-medium">{message}</span>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex gap-2">
              <div className="relative flex-1">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setStatus('idle'); }}
                  placeholder="tu@correo.com"
                  required
                  data-testid="newsletter-email-input"
                  className="w-full pl-10 pr-4 py-2.5 rounded-lg border-0 text-sm text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-green-400 outline-none"
                />
              </div>
              <button
                type="submit"
                disabled={status === 'loading'}
                data-testid="newsletter-submit-btn"
                className="px-5 py-2.5 bg-white text-green-800 font-semibold text-sm rounded-lg hover:bg-green-50 transition-colors disabled:opacity-60 flex-shrink-0"
              >
                {status === 'loading' ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  'Suscribirme'
                )}
              </button>
            </form>
          )}
          {status === 'error' && (
            <p className="text-red-300 text-xs mt-2">{message}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsletterSignup;
